import React from 'react';
import { Link } from 'react-router-dom';

function LoginModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <div className="login-modal-content">
          <h2 className="login-modal-title">Create an account to play</h2>
          <div className="login-modal-message">
            <p className="login-modal-text">
              Save your progress and sync across devices with a free Plate Chase account.
            </p>
            <p className="login-modal-subtext">
              Sign up with Google or email — it only takes a minute.
            </p>
          </div>
          <div className="login-modal-button-container">
            <Link to="/signup" className="login-modal-primary-btn" onClick={onClose}>
              Create account
            </Link>
          </div>
          <p className="login-modal-email-link">
            Already have an account?{' '}
            <Link to="/login" onClick={onClose}>
              Sign in
            </Link>
          </p>
          <button
            className="login-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginModal;
